module.exports = __webpack_public_path__ + "media/pleaseShowScan.2f388584.mp3";